import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
const links = [{
  to: '/',
  label: 'Accueil'
}, {
  to: '/boutique',
  label: 'Boutique'
}, {
  to: '/la-ferme',
  label: 'La ferme'
}, {
  to: '/visites',
  label: 'Visites'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const {
    count,
    open
  } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  React.useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-40 border-b border-line bg-cream/95 backdrop-blur" data-id="element-88" data-mp="31cqno0kvd56w">
      <div className="mx-auto flex max-w-page items-center gap-6 px-5 py-4 lg:px-8" data-id="element-89" data-mp="36aidmp1yeh8g">
        <Link to="/" className="flex items-baseline gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-olive" data-id="element-90" data-mp="3bbfvf0j1x99f">
          <span className="font-display text-lg font-semibold leading-none tracking-tight text-ink" data-id="element-91" data-mp="3f9nfa48taqou">
            GAEC Bru de la Roque
          </span>
        </Link>

        <nav aria-label="Navigation principale" className="ml-auto hidden items-center gap-7 md:flex" data-id="element-92" data-mp="2rkyjky1yzxsb">
          {links.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({
          isActive
        }) => `relative text-sm transition-colors duration-150 ease-soft hover:text-ink ${isActive ? 'text-ink' : 'text-muted'} after:absolute after:-bottom-1.5 after:left-0 after:h-px after:bg-olive after:transition-[width] after:duration-200 after:ease-soft ${isActive ? 'after:w-full' : 'after:w-0'}`} data-id="element-93" data-mp="2mohw862lhnga">
              {link.label}
            </NavLink>)}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:ml-0" data-id="element-94" data-mp="3talll6i63uif">
          <Link to="/visites" className="hidden rounded-full bg-olive px-4 py-2 text-sm font-medium text-cream transition-colors duration-150 ease-soft hover:bg-olive-dark lg:inline-block" data-id="element-95" data-mp="3t9adiuhow0li">
            Réserver une visite
          </Link>
          <button type="button" onClick={open} className="relative rounded-full border border-line p-2.5 text-ink transition-colors duration-150 ease-soft hover:border-olive hover:text-olive" aria-label={`Ouvrir le panier, ${count} article${count > 1 ? 's' : ''}`} data-id="element-96" data-mp="1hni07mybmlmx">
            <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-97" data-mp="1cmc8nsged4ez" />
            {count > 0 && <span className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-clay px-1 text-[11px] font-semibold text-cream" data-id="element-98" data-mp="13nz45sisb0qz">
                {count}
              </span>}
          </button>
          <button type="button" onClick={() => setMobileOpen(value => !value)} className="rounded-full border border-line p-2.5 text-ink md:hidden" aria-expanded={mobileOpen} aria-label="Menu" data-id="element-99" data-mp="2y0oyucgz8dzf">
            {mobileOpen ? <XIcon className="h-5 w-5" data-id="element-100" data-mp="w4psttqpwrza" /> : <MenuIcon className="h-5 w-5" data-id="element-101" data-mp="w60wzuo2s1qx" />}
          </button>
        </div>
      </div>

      {mobileOpen && <nav aria-label="Navigation mobile" className="border-t border-line bg-cream md:hidden" data-id="element-102" data-mp="rbobzg6yaid2">
          <ul className="mx-auto max-w-page px-5 py-3" data-id="element-103" data-mp="153bcjs7xed1n">
            {links.map(link => <li key={link.to} data-id="element-104" data-mp="105tbeo05h247">
                <NavLink to={link.to} end={link.to === '/'} className="block border-b border-line/60 py-3 text-base text-ink last:border-0" data-id="element-105" data-mp="1f3byzn13d9a2">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>}
    </header>;
}